import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { TpmService } from 'src/app/services/tpm.service';
import { mobile } from 'src/app/services/base-url';

function bufferToBase64url(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer);
  let str = '';
  for (const charCode of bytes) {
    str += String.fromCharCode(charCode);
  }
  const base64String = btoa(str);
  return base64String.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}

function base64urlToBuffer(base64url: string): ArrayBuffer {
  const padding = '='.repeat((4 - base64url.length % 4) % 4);
  const base64 = (base64url + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray.buffer;
}


@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
  userCred: any = [];
  userPrivileges: any = []
  usersWithoutCustomers: any = []
  selectedRoleData: any = []
  qrCode: any = "";
  authMode: any = "";
  otp: any = ""
  cid: any
  isTpmEnable: any = false
  userData: any;
  isFavouriteList: any = false;

  constructor(private translate: TranslateService, private sanitizer: DomSanitizer, private fb: FormBuilder, private toastr: ToastrService, private generic_service: GenericService, private tpmService: TpmService) { }

  ngOnInit(): void {
    this.userCred = JSON.parse(sessionStorage.getItem('userCreds')!);
    if (this.userCred) {
      this.tpmForm.toBeRegisteredUsername = this.userCred.userMobileNo || '';
    }
    this.userPrivileges = this.userCred?.rolePrevilages || [];

    const favScreenNames = new Set<string>();
    if (this.userCred?.favouriteList && Array.isArray(this.userCred.favouriteList)) {
      for (const role of this.userCred.favouriteList) {
        const groups = role.screenGroupList || (role.screenPrivilegeList ? [role] : []);
        for (const g of groups) {
          if (g.screenPrivilegeList && Array.isArray(g.screenPrivilegeList)) {
            for (const s of g.screenPrivilegeList) {
              if (s.name) favScreenNames.add(s.name);
            }
          }
        }
      }
    }

    for (let i = 0; i < this.userPrivileges.length; i++) {
      const screens = this.userPrivileges[i]?.screenPrivilegeList || [];
      let allChecked = screens.length > 0;
      for (let j = 0; j < screens.length; j++) {
        screens[j].isSubMenu = favScreenNames.has(screens[j].name);
        if (!screens[j].isSubMenu) {
          allChecked = false;
        }
      }
      this.userPrivileges[i].isMenu = allChecked && favScreenNames.size > 0;
    }
    console.log(this.userPrivileges)
    this.generic_service.getUserById(this.userCred.userId).subscribe(
      (response: any) => {
        console.log(response)
        this.userData = response.response
        this.isTpmEnable = response.response.userType == "BO"
        console.log(this.isTpmEnable)
      }
    )
    this.cid = Number(sessionStorage.getItem('cid'))

    const savedLang = localStorage.getItem('appLang') || 'en';
    this.selectedLang = savedLang;
    this.translate.setDefaultLang(savedLang);
    this.translate.use(savedLang);

    if (this.userCred.authMode == null) {
      this.authMode = 1;
    } else {
      this.authMode = this.userCred.authMode;
    }

    if (this.userCred.isFavouriteList != null) {
      this.isFavouriteList = this.userCred.isFavouriteList;
    }

  }

  privilegeAdjust(index: any, position: any) {
    var arr = this.userPrivileges;
    if (position == 'up') {
      var currentPosition = Number(index);
      var pos = Number(index) - 1;
      var temp = arr[currentPosition];
      var i;
      for (i = currentPosition; i >= pos; i--) {
        arr[i] = arr[i - 1];
      }
      arr[pos] = temp;
    }

    if (position == 'down') {
      var currentPosition = Number(index);
      var pos = Number(index) + 1;
      var temp = arr[currentPosition];
      var i;
      for (i = currentPosition; i <= pos; i++) {
        arr[i] = arr[i + 1];
      }
      arr[pos] = temp;
    }
  }

  screenPrivilegeListAdjust(privilegeIndex: any, screenIndex: any, position: any) {
    var arr = this.userPrivileges[privilegeIndex].screenPrivilegeList;
    if (position == 'up') {
      var currentPosition = Number(screenIndex);
      var pos = Number(screenIndex) - 1;
      var temp = arr[currentPosition];
      var i;
      for (i = currentPosition; i >= pos; i--) {
        arr[i] = arr[i - 1];
      }
      arr[pos] = temp;
    }

    if (position == 'down') {
      var currentPosition = Number(screenIndex);
      var pos = Number(screenIndex) + 1;
      var temp = arr[currentPosition];
      var i;
      for (i = currentPosition; i <= pos; i++) {
        arr[i] = arr[i + 1];
      }
      arr[pos] = temp;
    }
  }

  updatePosition() {
    console.log(this.userPrivileges)

    let body = {
      "version": this.userData.version,
      "isActive": this.userData.isActive,
      "description": this.userData.description,
      "id": this.userData.id,
      "userId": this.userData.userId,
      "userType": this.userData.userType,
      "userName": this.userData.userName,
      "authMode": this.userData.authMode,
      "userMobileNo": this.userData.userMobileNo,
      "userEmail": this.userData.userEmail,
      "password": this.userData.password,
      "imageURL": this.userData.imageURL,
      "roleLevel": this.userData.roleLevel,
      "companyName": this.userData.companyName,
      "allowDeploymentFromAnyLocation": this.userData.allowDeploymentFromAnyLocation,
      "dashboardIds": this.userData.dashboardIds,
      "branchId": this.userData.branchId,
      "reportsTo": this.userData.reportsTo,
      "otp": this.userData.otp,
      "otpGenerateDateTime": this.userData.otpGenerateDateTime,
      "locations": this.userData.locations,
      "department": this.userData.department,
      "branch": this.userData.branch,
      "groupMasterList": this.userData.groupMasterList,
      "keyValues": this.userData.keyValues,
      "preferences": this.userData.preferences,
      "isInnerUser": this.userData.isInnerUser,
      "roleIdSet": this.userData.roleIdSet,
      "cid": this.cid,
      "location": this.userData.location
    }

  }


  @ViewChild('myimage')
  myimage!: ElementRef;

  authChanged(event: any) {
    const selectedValue = event.target.value;
    console.log("authChanged triggered with value:", selectedValue);

    if (selectedValue == '2') {
      if (!this.userCred || !this.userCred.userMobileNo) {
        this.toastr.warning("Mobile number not found in profile.");
        this.cancelQrCode();
        return;
      }
      this.generic_service.generate2StepAuthenticationKey(this.userCred.userMobileNo).subscribe(
        (response: any) => {
          if (response && response.response) {
            let url = response.response;

            // If the Google Charts URL is failing, switch to api.qrserver.com which is more robust for otpauth URIs
            if (url.includes('chl=')) {
              let parts = url.split('chl=');
              let data = parts[1];
              url = 'https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=' + encodeURIComponent(decodeURIComponent(data));
            }

            this.qrCode = this.sanitizer.bypassSecurityTrustUrl(url);
            console.log("Final QR URL:", url);

            // Open the modal by clicking the hidden button
            setTimeout(() => {
              const btn = document.getElementById("authButton");
              if (btn) {
                btn.click();
              } else {
                console.error("authButton not found");
              }
            }, 100);
          }
        },
        (error: any) => {
          console.error("Error generating 2FA key:", error);
          this.toastr.error("Failed to generate authentication key");
          this.cancelQrCode();
        }
      )
    }
    if (selectedValue == '1') {
      setTimeout(() => {
        const btn = document.getElementById("authButton1");
        if (btn) {
          btn.click();
        } else {
          console.error("auth not found");
        }
      }, 100);
    }
  }

  menuDisplayChanged(event: any) {
    const isFavouriteListStr = event.target.value;
    const isFavouriteList = isFavouriteListStr === 'true';

    this.generic_service.updateIsFavouriteListForUsers(this.userCred.userId, this.cid, isFavouriteList).subscribe(
      (response: any) => {
        this.toastr.success(response.message || 'Menu display updated successfully');
        this.userCred.isFavouriteList = isFavouriteList;
        sessionStorage.setItem('userCreds', JSON.stringify(this.userCred));
        this.generic_service.menuRefresh.next(true);
      },
      (error: any) => {
        console.error("Error updating menu display:", error);
        this.toastr.error('Failed to update menu display');
      }
    );
  }

  update() {

    if (this.otp == "" || this.otp == null || this.otp == undefined) {
      this.toastr.warning("Please enter a valid OTP")
      return
    }

    let body = {
      "userPhone": this.userCred.userMobileNo,
      "authMode": Number(this.authMode),
      "otp": this.otp,
      "cid": this.cid
    }

    console.log(body)

    this.generic_service.updateUserAuthMode(body).subscribe(
      (response: any) => {
        console.log(response)
        this.otp = ""
        this.toastr.success(response.message)
        this.logout()
      },
      (err: any) => {
        console.log(err)
        this.otp = ""
        this.toastr.error(err.error.errors[0].description)
      }
    )
  }

  logout() {
    localStorage.clear()
    sessionStorage.clear()
    window.location.href = "/login"
  }

  cancelQrCode() {
    this.qrCode = "";
    console.log(this.authMode)
    if (this.userCred.authMode == null) {
      this.authMode = 1;
    } else {
      this.authMode = this.userCred.authMode;
    }
    console.log(this.authMode)
  }


  switchLang(lang: string) {
    this.translate.use(lang);
    localStorage.setItem('appLang', lang); // persist
  }

  languages: any = [
    { label: 'English', value: 'en' },
    { label: 'French', value: 'fr' },
    { label: 'Hindi', value: 'hi' },
    { label: 'Telugu', value: 'te' },
    { label: 'Arabic', value: 'ar' },
    { label: 'German', value: 'de' }
  ];

  selectedLang = 'en';

  onLangChange() {
    this.translate.use(this.selectedLang);
    localStorage.setItem('appLang', this.selectedLang);
  }

  updateUserPreference() {
    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "id": this.userCred.id,
      "userId": this.userCred.userId,
      "preferences": {
        "localization": {
          "country": "",
          "language": this.selectedLang,
          "timezone": "",
          "dateFormat": "",
          "currency": ""
        }
      },
      "cid": this.cid
    }

    console.log(body)

    this.generic_service.updateUserPreference(body).subscribe(
      (response: any) => {
        console.log(response)
        this.toastr.success(response.message)
        this.translate.use(this.selectedLang);
        localStorage.setItem('appLang', this.selectedLang);
        // this.logout()
      },
      (err: any) => {
        console.log(err)
        this.toastr.error(err.error.errors[0].description)
      }
    )
  }

  tpmForm: any = {
    registrarOtp: '',
    toBeRegisteredUsername: '',
    toBeRegisteredPassword: '',
    toBeRegisteredOtp: ''
  };

  registrarPassword: any = "";

  openTpmModal() {
    this.registrarPassword = "";
    const btn = document.getElementById("passwordPromptButton");
    if (btn) btn.click();
  }

  registerOtp() {
    if (!this.registrarPassword) {
      this.toastr.warning("Please enter a valid password");
      return;
    }

    const closeBtn = document.getElementById("closePasswordPromptButton");
    if (closeBtn) closeBtn.click();

    this.tpmForm = {
      "registrarUsername": this.userCred.userName,
      "registrarPassword": this.registrarPassword,
      "toBeRegisteredPhone": this.userCred.userMobileNo,
      "cid": this.cid
    };

    this.tpmService.registerOtp(this.tpmForm).subscribe(
      (res: any) => {
        console.log('OTP generated', res);
        this.toastr.success(res.response);

        this.toastr.success('OTPs generated successfully');
        const btn = document.getElementById("tpmModalButton");
        if (btn) btn.click();
      },
      (err: any) => {
        console.error(err);
        this.toastr.error('Failed to generate OTP');
      }
    );
  }

  async submitTpmRegistration() {
    const optionsBody = {
      registrarUsername: mobile,
      registrarOtp: this.tpmForm.registrarOtp,
      toBeRegisteredUsername: this.userCred.userMobileNo,
      toBeRegisteredPassword: this.tpmForm.toBeRegisteredPassword,
      toBeRegisteredOtp: this.tpmForm.toBeRegisteredOtp,
      cid: this.cid,
      credentialJson: ""
    };

    try {
      const optionsRes: any = await this.tpmService.registerOptions(optionsBody).toPromise();

      let publicKeyCredentialCreationOptions = JSON.parse(optionsRes.response.optionsJson);
      publicKeyCredentialCreationOptions = publicKeyCredentialCreationOptions.publicKey || publicKeyCredentialCreationOptions;

      if (typeof publicKeyCredentialCreationOptions.challenge === 'string') {
        publicKeyCredentialCreationOptions.challenge = base64urlToBuffer(publicKeyCredentialCreationOptions.challenge);
      }
      if (publicKeyCredentialCreationOptions.user && typeof publicKeyCredentialCreationOptions.user.id === 'string') {
        publicKeyCredentialCreationOptions.user.id = base64urlToBuffer(publicKeyCredentialCreationOptions.user.id);
      }
      if (publicKeyCredentialCreationOptions.excludeCredentials) {
        for (let cred of publicKeyCredentialCreationOptions.excludeCredentials) {
          if (typeof cred.id === 'string') {
            cred.id = base64urlToBuffer(cred.id);
          }
        }
      }

      const credential: any = await navigator.credentials.create({
        publicKey: publicKeyCredentialCreationOptions
      });

      const credentialJson = JSON.stringify({
        id: credential.id,
        rawId: bufferToBase64url(credential.rawId),
        type: credential.type,
        response: {
          attestationObject: bufferToBase64url(credential.response.attestationObject),
          clientDataJSON: bufferToBase64url(credential.response.clientDataJSON)
        }
      });

      const verifyBody = {
        username: this.userCred.userMobileNo,
        cid: this.cid,
        credentialJson: credentialJson
      };

      const verifyRes: any = await this.tpmService.registerVerify(verifyBody).toPromise();
      console.log('Verify Response:', verifyRes);
      this.toastr.success('TPM Registration successful!');

      const closeBtn = document.getElementById("closeTpmModalButton");
      if (closeBtn) closeBtn.click();

    } catch (err: any) {
      console.error(err);
      this.toastr.error('TPM Registration failed!');
    }
  }
  onMenuChange(rolePrevilage: any) {
    if (rolePrevilage.isMenu) {
      rolePrevilage.screenPrivilegeList.forEach((screen: any) => {
        screen.isSubMenu = true;
      });
    } else {
      rolePrevilage.screenPrivilegeList.forEach((screen: any) => {
        screen.isSubMenu = false;
      });
    }
  }

  onSubMenuChange(rolePrevilage: any) {
    const allChecked = rolePrevilage.screenPrivilegeList.every((screen: any) => screen.isSubMenu);
    rolePrevilage.isMenu = allChecked;
  }

  updateFavouriteList() {
    let screenGroupList: any[] = [];

    for (let i = 0; i < this.userPrivileges.length; i++) {
      let group = this.userPrivileges[i];
      let checkedSubmenus = group.screenPrivilegeList.filter((screen: any) => screen.isSubMenu === true);

      if (checkedSubmenus.length > 0) {
        let newGroup = { ...group };
        newGroup.screenPrivilegeList = checkedSubmenus;
        screenGroupList.push(newGroup);
      }
    }

    let payload = {
      userId: this.userCred.userId,
      cid: this.cid,
      favouriteList: [
        {
          id: "",
          roleId: 0,
          roleName: "Favourite",
          level: 0,
          screenGroupList: screenGroupList,
          cid: this.cid
        }
      ]
    };

    console.log("Updating favourite list:", payload);

    this.generic_service.updateFavouriteList(payload).subscribe(
      (res: any) => {
        this.toastr.success(res.message || 'Favourites updated successfully');
        this.userCred.favouriteList = payload.favouriteList;
        sessionStorage.setItem('userCreds', JSON.stringify(this.userCred));
        this.generic_service.menuRefresh.next(true);
      },
      (err: any) => {
        console.error(err);
        this.toastr.error('Failed to update favourites');
      }
    );
  }

}
